import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMPocketErrorType } from '#src/types/DMPocketErrorTypes'

export default class DMMoneyError extends BaseError<DMPocketErrorType> {
  constructor(
    public message: string,
    public code: DMPocketErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMMoneyError.prototype)
    this.name = this.constructor.name
  }
}
